import { Progress } from "@shared/src/components/ui/progress";
import { useCountdown } from "@shared/src/utils/helpers/countdown";

export function ProgressWithTimer({
  targetDate,
  totalTime,
  reverse,
}: {
  targetDate: Date;
  totalTime: number;
  reverse?: boolean;
}) {
  const { timeLeft } = useCountdown({ targetDate });
  const currentProgress = (timeLeft.totalInMilliSeconds / totalTime) * 100;
  return <Progress value={reverse ? currentProgress : 100 - currentProgress} className="w-full mt-2" />;
}
